(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.dashboard-pending-loans', [
    'pp.widgets-templates',
    'pp.widgets.dashboard-card-pending',
    'pp.services.dashboard'
]);

ngModule.component('ppDashboardPendingLoans', {
    templateUrl: 'widgets/_angular/dashboard-pending-loans/dashboard-pending-loans.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', 'dashboardService', function ($scope, dashboardService) {
        var vm = this;

        // -- initial state

        // -- util functions

        function init() {
            return dashboardService.getPendingLoans().then(function (data) {
                vm.data = data;
                vm.loadError = false;
            }, function () {
                vm.loadError = true;
            });
        }

        // -- api

        // -- scope bindings

        // -- main

        init().then(function () {
            vm.ready = true;
        });

    }]
});
})(window, window.angular);